import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from "./pages/dashboard/dashboard.component";
import { ContactsComponent } from "./pages/contacts/contacts/contacts.component";
import { AddcontactsComponent } from "./pages/contacts/addcontacts/addcontacts.component";
import { ReceiptsComponent } from "./pages/receipts/receipts/receipts.component";
import { GenerateReceiptsComponent } from "./pages/receipts/generate-receipts/generate-receipts.component";
import { AddreceiptsComponent } from "./pages/receipts/addreceipts/addreceipts.component";
import { AddClientContactComponent } from './pages/contacts/addClientContact/add-client-contact.component';
import { MainPageComponent } from "../app/POC/main-page/main-page.component";
import { SearchDetaiesComponent } from "../app/pages/search/search-detaies/search-detaies.component";
import { MagazineComponent } from "../app/pages/magazine/magazine/magazine.component";
import { LoginComponent } from "../app/pages/auth/login/login.component";
import { AuthGuardService } from "./services/auth/authGuard/auth-guard.service";
import { DonationComponent } from './pages/donation/donation/donation.component';
import { DonationListComponent } from './pages/donation/donation-list/donation-list.component';
import { ContactListComponent } from './pages/contacts/contactList/contact-list.component';
import { DuplicatePartnerMappingComponent } from './pages/contacts/duplicate-partner-mapping/duplicate-partner-mapping.component';
import { EventListComponent } from "./pages/events/event-list/event-list.component";
import { XlxsDownloadComponent } from "./POC/xlxs-download/xlxs-download.component";
import { EventRegistrationComponent } from './pages/events/event-registration/event-registration.component';
import { EventsContactListComponent } from './pages/events/events-contact-list/events-contact-list.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    data: { requiresLogin: true },
    canActivate: [AuthGuardService]
  },
  {
    path: 'contacts',
    component: ContactsComponent,
    data: { requiresLogin: true },
    canActivate: [AuthGuardService]
  },
  {
    path: 'addContact',
    component: AddcontactsComponent,
    data: { requiresLogin: true },
    canActivate: [AuthGuardService]
  },
  {
    path: 'addClientContact',
    component: AddClientContactComponent,
    data: { requiresLogin: true },
    canActivate: [AuthGuardService]
  },
  {
    path: 'contactList',
    component: ContactListComponent,
    data: { requiresLogin: true },
    canActivate: [AuthGuardService]
  },
  {
    path: 'duplicatePartnerMapping',
    component: DuplicatePartnerMappingComponent,
    data: { requiresLogin: true },
    canActivate: [AuthGuardService]
  },
  {
    path: 'TestClientContact',
    component: AddClientContactComponent,
    data: {
      expectedComponents: 'LOW'
    }
  },
  {
    path: 'receipts',
    component: ReceiptsComponent,
    data: { requiresLogin: true },
    canActivate: [AuthGuardService]
  },
  {
    path: 'addreceipt',
    component: AddreceiptsComponent,
    data: { requiresLogin: true },
    canActivate: [AuthGuardService]
  },
  {
    path: 'genreceipt',
    component: GenerateReceiptsComponent,
    data: { requiresLogin: true },
    canActivate: [AuthGuardService]
  },
  {
    path: 'POC',
    component: MainPageComponent,
    data: {
      expectedComponents: 'LOW'
    }
  },
  {
    path: 'search',
    component: SearchDetaiesComponent,
    data: { requiresLogin: true },
    canActivate: [AuthGuardService]
  },
  {
    path: 'magazine',
    component: MagazineComponent,
    data: { requiresLogin: true },
    canActivate: [AuthGuardService]
  },
  {
    path: 'donate',
    component: DonationComponent,
    data: { requiresLogin: true },
    canActivate: [AuthGuardService]
  },
  {
    path: 'donateList',
    component: DonationListComponent,
    data: { requiresLogin: true },
    canActivate: [AuthGuardService]
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      expectedComponents: 'FULL'
    }
  },
  {
    path: 'eventList',
    component: EventListComponent,
    data: {
      expectedComponents: 'FULL'
    }
  },
  {
    path: 'remoteContactList',
    component: ContactListComponent,
    data: {
      expectedComponents: 'FULL'
    }
  },
  {
    path: 'eventRegistration',
    component: EventRegistrationComponent,
    data: {
      expectedComponents: 'FULL'
    }
  },
  {
    path: 'event-contact-list',
    component: EventsContactListComponent,
    data: {
      expectedComponents: 'FULL'
    }
  },
  {
    path: 'edit-contact/:id',
    component: EventsContactListComponent,
    data: {
      expectedComponents: 'FULL'
    }
  },
  {
    path: 'xlsx',
    component: XlxsDownloadComponent,
    data: {
      expectedComponents: 'LOW'
    }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
